module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-Telluride-Playful-v2.788e447e.jpeg";